<template>
	<div>
		<div class="message-text text-dark fw-bold mw-lg-400px fs-14px rounded p-5">
			<div class="mb-4 d-flex align-items-center gap-3">
				<i class="icon bi bi-megaphone-fill"></i>
				<span class="fs-5">
					{{ $t('campaigns.chat.your-marketing-campaign-has-been-sent') }} "{{
						message?.extra_data?.campaign?.name
					}}"
					<span class="view-message" @click="$emit('show-template', message)">{{
						$t('campaigns.chat.click-to-view-message')
					}}</span>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	message: Object,
});
</script>

<style lang="scss" scoped>
@import './styles/chat.scss';

.text-link {
	cursor: pointer;
}
.text-link:hover {
	text-decoration: underline;
}
.view-message {
	color: var(--bs-primary);
	text-decoration: underline;
	cursor: pointer;
}
.icon {
	&:before {
		font-size: 23px;
		color: var(--bs-primary);
	}
}
</style>
